<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-navigation-drawer
      permanent
      fixed
      :mini-variant="mobileBreakpoints()"
      :mini-variant-width="40"
      color="RMblack"
      height="100%"
      width="100"
      clipped
    >
      <v-list>
        <v-list-item class="mt-2 text-center margin-logo">
          <v-list-item-avatar>
            <img
              :src="require('@/assets/radarmeteo-marchio.png')"
              class="logo-size"
              style="cursor: pointer"
              @click="resetDrawer()"
            >
          </v-list-item-avatar>
        </v-list-item>
        <div
          v-if="stage !== 'prod'"
          v-show="!mobileBreakpoints()"
          class="d-flex justify-center my-2"
        >
          <v-chip
            x-small
            color="amber darken-2"
            text-color="black"
            class="rounded font-weight-black"
          >
            {{ stage.toUpperCase() }}
          </v-chip>
        </div>
        <span
          v-show="!mobileBreakpoints()"
          class="d-block text-center mt-2"
          style="font-size:12px; color:white"
        >
          {{ updatedDate }}
          <br>
          {{ updatedHour }}
        </span>
      </v-list>
      <v-divider class="custom-divider" />
      <v-list dense>
        <v-skeleton-loader
          v-if="!app_user.listAppUserEnabledServicesReady"
          class="mx-auto"
          type="table-cell@3"
        />
        <v-list-item-group
          :class="
            drawer.drawerTitle === 'NavigationDrawer.archive' || ($route.params.id === 'Archive' && !drawer.drawerVisibility)
              ? 'active-item '
              : 'not-active-item'
          "
        >
          <span
            v-if="app_user.listAppUserEnabledServices.some(item=> {
              if(item.service_type === 'WS'){
                return item.service_ws_group.some(item=> item === 'Archive')
              }
            })"
            @click="
              openDynamicNavigationDrawerWorkspace('Archive', 'NavigationDrawer.archive')
            "
          >
            <ListItemIcon>
              <template v-slot:icon>
                <SvgIcon
                  :color1="'#000000'"
                  :color2="'#FFFFFF'"
                  :title="$t('NavigationDrawer.archive')"
                  :path="archiveSvg"
                />
              </template>
              <template v-slot:text>
                <span
                  class="icon-description"
                >
                  {{ $t('NavigationDrawer.archive') }}
                </span>
              </template>
            </ListItemIcon>
          </span>
        </v-list-item-group>
        <v-list-item-group
          :class="
            drawer.drawerTitle === 'NavigationDrawer.real_time' || ($route.params.id === 'Real-Time' && !drawer.drawerVisibility)
              ? 'active-item '
              : 'not-active-item'
          "
        >
          <span
            v-if="app_user.listAppUserEnabledServices.some(item=> {
              if(item.service_type === 'WS'){
                return item.service_ws_group.some(item=> item === 'Real-Time')
              }
            })"
            @click="
              openDynamicNavigationDrawerWorkspace('Real-Time', 'NavigationDrawer.real_time' )
            "
          >
            <ListItemIcon>
              <template v-slot:icon>
                <SvgIcon
                  :color1="'#000000'"
                  :color2="'#FFFFFF'"
                  :title="$t('NavigationDrawer.real_time')"
                  :path="realTimeSvg"
                />
              </template>
              <template v-slot:text>
                <span
                  class="icon-description"
                >
                  {{ $t('NavigationDrawer.real_time') }}
                </span>
              </template>
            </ListItemIcon>
          </span>
        </v-list-item-group>
        <v-list-item-group
          :class="
            drawer.drawerTitle === 'NavigationDrawer.prevision' || ($route.params.id === 'Forecast' && !drawer.drawerVisibility)
              ? 'active-item '
              : 'not-active-item'
          "
        >
          <span
            v-if="app_user.listAppUserEnabledServices.some(item=> {
              if (item.service_type === 'WS') {
                return item.service_ws_group.some(item=> item === 'Forecast')
              }
            })"
            @click="
              openDynamicNavigationDrawerWorkspace('Forecast', 'NavigationDrawer.prevision' )
            "
          >
            <ListItemIcon>
              <template v-slot:icon>
                <SvgIcon
                  :color1="'#000000'"
                  :color2="'#FFFFFF'"
                  :title="$t('NavigationDrawer.prevision')"
                  :path="forecastSvg"
                />
              </template>
              <template v-slot:text>
                <span
                  class="icon-description"
                >
                  {{ $t('NavigationDrawer.prevision') }}
                </span>
              </template>
            </ListItemIcon>
          </span>
        </v-list-item-group>
        <v-divider class="custom-divider" />
        <v-skeleton-loader
          v-if="!app_user.listAppUserEnabledServicesReady"
          class="mx-auto"
          type="table-cell@2"
        />
        <v-list-item-group
          v-for="navigationItem of navigationDrawerServices"
          :key="navigationItem.translationPath"
          :class="
            drawer.drawerTitle == navigationItem.translationPath
              ? 'active-item '
              : 'not-active-item'
          "
        >
          <span
            v-if="app_user.listAppUserEnabledServices.some(item=> item.service_type === 'URL' || item.service_type === 'DOC' || item.service_type === 'ALERT EX-POST')"
            @click="
              openDynamicNavigationDrawer(navigationItem.translationPath, navigationItem.service_type)
            "
          >
            <ListItemIcon>
              <template v-slot:icon>
                <SvgIcon
                  :color1="'#000000'"
                  :color2="'#FFFFFF'"
                  :title="$t(`${navigationItem.translationPath}`)"
                  :path="navigationItem.svg"
                />
              </template>
              <template v-slot:text>
                <span class="icon-description">
                  {{ $t(navigationItem.translationPath) }}
                </span>
              </template>
            </ListItemIcon>
          </span>
        </v-list-item-group>
        <v-list-item-group
          v-for="navigationItem of navigationDrawerOperativeSupport"
          :key="navigationItem.translationPath"
          :class="
            drawer.drawerTitle == navigationItem.translationPath
              ? 'active-item '
              : 'not-active-item'
          "
        >
          <span
            v-if="app_user.listAppUserEnabledServices.some(item => item.service_type === 'TICKET' || item.service_type === 'REPORTS' || item.service_type === 'REPORT-HUB')"
            @click="
              openDynamicNavigationDrawer(navigationItem.translationPath, navigationItem.service_type)
            "
          >
            <ListItemIcon>
              <template v-slot:icon>
                <SvgIcon
                  :color1="'#000000'"
                  :color2="'#FFFFFF'"
                  :title="$t(`${navigationItem.translationPath}`)"
                  :path="navigationItem.svg"
                />
              </template>
              <template v-slot:text>
                <span class="icon-description">
                  {{ $t(navigationItem.translationPath) }}
                </span>
              </template>
            </ListItemIcon>
          </span>
        </v-list-item-group>
      </v-list>
      <v-list
        class="bottom-icon"
        dense
      >
        <v-list-item-group
          v-for="navigationItem of navigationDrawerSettings"
          :key="navigationItem.translationPath"
          :class="
            drawer.drawerTitle == navigationItem.translationPath
              ? 'active-item '
              : 'not-active-item'
          "
        >
          <span
            @click="
              openDynamicNavigationDrawer(navigationItem.translationPath)
            "
          >
            <ListItemIcon>
              <template v-slot:icon>
                <SvgIcon
                  :color1="'#000000'"
                  :color2="'#FFFFFF'"
                  :title="$t(`${navigationItem.translationPath}`)"
                  :path="navigationItem.svg"
                />
              </template>
              <!-- <template v-slot:text>
                      <span class="icon-description">
                        {{ $t(navigationItem.translationPath) }}
                      </span>
                    </template> -->
            </ListItemIcon>
          </span>
        </v-list-item-group>
        <v-divider class="custom-divider" />
        <v-list-item-group>
          <div @click="signOut">
            <ListItemIcon>
              <template
                v-slot:icon
              >
                <SvgIcon
                  :color1="'#000000'"
                  :color2="'#FFFFFF'"
                  :title="$t('NavigationDrawer.logOut')"
                  :path="logoutSvg"
                />
              </template>
            </ListItemIcon>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import { STAGE } from '@/constants.js';
import { getFormattedDate } from '@/utils.js';
import { mapActions, mapState } from 'vuex';
import {
  svgArchive, svgRealTime, svgForecast,
  svgAdditionalServices, svgOperativeSupport,
  svgSettings, svgSupport, svgLogout
} from '@/svg.js';

export default {
  components: {
    ListItemIcon: () => import('@/components/utils/ListItemIcon'),
    SvgIcon: () => import('@/components/utils/SvgIcon')
  },
  data() {
    return {
      updatedDate: '',
      updatedHour: '',
      stage: STAGE,
      overlay: false,
      archiveSvg: svgArchive,
      realTimeSvg: svgRealTime,
      forecastSvg: svgForecast,
      logoutSvg: svgLogout,
      navigationDrawerServices: [
        {
          translationPath: 'NavigationDrawer.services',
          svg: svgAdditionalServices,
          title: 'NavigationDrawer.services',
          service_type: 'URL'
        }
      ],
      navigationDrawerOperativeSupport: [
        {
          translationPath: 'NavigationDrawer.operative_support',
          svg: svgOperativeSupport,
          title: 'NavigationDrawer.operative_support',
          service_type: 'TICKET'
        }
      ],
      navigationDrawerSettings: [
        {
          translationPath: 'NavigationDrawer.settings',
          svg: svgSettings,
          title: 'NavigationDrawer.settings',
          service_type: 'URL'
        },
        {
          translationPath: 'NavigationDrawer.support',
          svg: svgSupport,
          title: 'NavigationDrawer.support',
          service_type: 'URL'
        }
        // {
        //   translationPath: "NavigationDrawer.notifications",
        //   svg: 'M11.6533108,2 C12.9403912,2 13.9830489,3.0619661 13.9830489,4.37155932 L13.9830489,4.46027797 C16.5506864,5.43617627 18.3097052,7.94807458 18.3097052,10.8134983 L18.3097052,14.8812949 C19.4095746,14.8812949 20.3066236,15.7923119 20.3066236,16.9151932 C20.3066236,18.0380746 19.4108726,18.9490915 18.3058113,18.9490915 L14.6447963,18.9490915 C14.5576907,20.5552949 13.2524117,21.8304475 11.6533128,21.8304475 C10.0542139,21.8304475 8.7489282,20.5552949 8.66182928,18.9490915 L5.00081233,18.9490915 C3.895751,18.9490915 3,18.0393966 3,16.9151932 C3,15.7923119 3.894453,14.8812949 4.99821633,14.8812949 C4.99812348,14.8812949 4.99803725,14.8605409 4.99795719,14.8219976 L4.99701867,12.4145261 C4.99701014,12.3433693 4.99700233,12.2729538 4.99699516,12.20365 L4.99691634,10.8134983 L4.99691634,10.8134983 C4.99691634,7.94804068 6.75593514,5.43621017 9.32357273,4.46027797 L9.32357273,4.37155932 C9.32357273,3.0619661 10.3675284,2 11.6533108,2 Z M13.3096567,18.9490915 L9.99703544,18.9490915 C10.0815417,19.8058034 10.7900783,20.4745153 11.6533461,20.4745153 C12.5166139,20.4745153 13.2251538,19.8058034 13.3096567,18.9490915 Z M11.7,3.32542373 C11.5499473,3.32542373 11.4077687,3.36300118 11.280457,3.43024725 C10.9139581,3.58042502 10.6547871,3.9457542 10.6547871,4.37150847 L10.6547871,5.45994915 L10.1738293,5.6016339 C7.9142829,6.26502373 6.32809738,8.37970169 6.32809738,10.8134983 L6.32809738,14.8812949 C6.32809738,15.6294305 5.73135162,16.2372271 4.99811649,16.2372271 C4.63018428,16.2372271 4.33117904,16.5417831 4.33117904,16.9151932 C4.33117904,17.289939 4.6301976,17.5931593 5.00071248,17.5931593 L18.3058465,17.5931593 C18.6750767,17.5931593 18.97538,17.2886034 18.97538,16.9151932 C18.97538,16.5417831 18.6750634,16.2372271 18.3084425,16.2372271 C17.5739094,16.2372271 16.9784616,15.6320746 16.9784616,14.8812949 L16.9784616,10.8134983 C16.9784616,8.38102373 15.392376,6.26502373 13.1327297,5.6016339 L12.6517054,5.45994915 L12.6517054,4.37150847 L12.649,4.325 L12.6833333,4.32542373 C12.6331629,3.76380151 12.2125126,3.32542373 11.7,3.32542373 Z',
        //   title: "NavigationDrawer.notifications",
        //   service_type: "URL"
        // }
      ]
    };
  },
  computed: {
    ...mapState(['drawer', 'app_user', 'policy', 'map', 'wsServices'])
  },
  mounted() {
    this.formatNewDate();
    setInterval(this.formatNewDate, 1000);
  },
  methods: {
    ...mapActions(['storeEnabledServicesPolicy', 'storeCustomerGlobalLayers', 'resetDrawer', 'removeAllActiveServices']),
    async signOut() {
      await api.logOff();
      this.$router.push('/');
      location.reload();
    },
    getColor() {
      return this.$vuetify.theme.dark ? 'fill: #000000' : 'fill: #FFFFFF';
    },
    isLandscape() {
      return /Mobi|Android/i.test(navigator.userAgent) && window.innerHeight < window.innerWidth;
    },
    mobileBreakpoints() {
      return /Mobi|Android/i.test(navigator.userAgent) || this.isLandscape();
    },
    async openDynamicNavigationDrawer(title, service_type) {
      this.removeAllActiveServices();
      this.drawer.drawerVisibility = null;
      this.drawer.drawerVisibility = true;
      this.drawer.drawerTitle = title;
      this.drawer.workspaceSidebar = false;
      this.overlay = true;
      await this.storeEnabledServicesPolicy({
        app_user_id: this.app_user.app_user_id,
        service_type: service_type
      });

      if (title === 'NavigationDrawer.operative_support') {
        await this.storeEnabledServicesPolicy({
          app_user_id: this.app_user.app_user_id,
          service_type: 'REPORTS'
        });
      }

      this.overlay = false;
      this.$gtag.event('Macroservizio', {
        event_category: title.split('.')[1] === 'services' ? 'Additional services' : title.split('.')[1],
        event_label: `${Date.now()} - ${this.app_user.username} - ${this.app_user.crm_id} - ${getFormattedDate(new Date(), true, true)}`,
        value: title.split('.')[1] === 'services' ? 'Additional services' : title.split('.')[1]
      });
    },
    async openDynamicNavigationDrawerWorkspace(title, translationPath) {
      if (this.$route.params.id !== title) {
        this.$gtag.event('Macroservizio', {
          event_category: title,
          event_label: `${Date.now()} - ${this.app_user.username} - ${this.app_user.crm_id} - ${getFormattedDate(new Date(), true, true)}`,
          value: title
        });
        this.$router.push({
          name: 'Map',
          params: { id: title }
        });
        const data = {
          app_user_id: this.app_user.app_user_id,
          service_type: 'WS',
          ws_group: title
        };
        this.overlay = true;
        this.removeAllActiveServices();
        await this.storeEnabledServicesPolicy(data);

        if (this.policy.enabledServicesPolicy.WS.length > 0) {
          this.drawer.workspaceSidebar = true;
          this.drawer.disableWorkspaceSidebar = false;
        } else {
          this.drawer.workspaceSidebar = false;
          this.drawer.disableWorkspaceSidebar = true;
        }

        await this.storeCustomerGlobalLayers(this.app_user.crm_id);

        this.overlay = false;
        this.drawer.drawerVisibility = false;
        this.drawer.drawerTitle = translationPath;
        this.specificDefaultService(title.replace('-', ''));
      }
    },
    formatNewDate() {
      const date = new Date();
      const m = date.getMinutes();
      const h = date.getHours();
      let month = '' + (date.getMonth() + 1);
      let day = '' + date.getDate();
      const year = date.getFullYear();

      if (month.length < 2) {
        month = '0' + month;
      }

      if (day.length < 2) {
        day = '0' + day;
      }

      this.updatedDate = day + '/' + month + '/' + year;
      this.updatedHour = ('0' + h).substr(-2) + ':' + ('0' + m).substr(-2);
    },
    specificDefaultService(scope) {
      if (this.app_user.defaultService[scope]) {
        this.map.specificDefaultService[scope] = true;
      }
    }
  }
};
</script>

<style scoped>
.custom-divider {
  margin: 0.7em;
  border-color: white !important;
}
.icon-description {
  font-size: 11px;
  color: white;
}
.side-bar-icon {
  min-width: 69px;
  min-height: 78px;
}
.bottom-icon {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.active-item {
  background-color: #136d33 !important;
  border-color: #136d33 !important;
}
.not-active-item {
  background: black;
}
.margin-logo {
  margin-left: 14px;
}
@media (min-device-width:280px) and (max-device-width:600px){
  .margin-logo {
    margin-left: -1px;
  }
  .logo-size /deep/ {
    object-fit: contain;
    object-position: center top;
    width: 24px;
    height: 24px;
    /* margin-right: 17px !important; */
  }
}
@media (max-device-width:850px) and (min-device-height:280px) and (orientation: landscape) {
  .margin-logo {
    margin-left: 10px;
  }
  .logo-size /deep/ {
    object-fit: contain;
    object-position: center top;
    width: 40px;
    height: 40px;
    /* margin-right: 17px !important;
    margin-left: 6px !important; */
  }
  .icon-description {
    font-size: 9px;
    color: white;
  }
}
@media (max-device-height:501px) and (orientation: portrait) {
  .bottom-icon {
    position: relative;
  }
}
@media (max-device-height:650px) and (orientation: landscape) {
  .bottom-icon {
    position: relative;
  }
}
</style>
